<div class="player-container">
    <div class="player-header">
        <h2>{{ currentVideo.title }}</h2>
        <button mat-icon-button (click)="closeDialog()" aria-label="Fechar player">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="video-wrapper">
        <ng-container *ngIf="!isPdf(); else pdfViewer">
            <video #videoPlayer controls autoplay
                (click)="videoPlayer.paused ? videoPlayer.play() : videoPlayer.pause()">
                <source [src]="currentVideo.videoUrlFile" type="video/mp4">
                Seu navegador não suporta a tag de vídeo.
            </video>
        </ng-container>

        <ng-template #pdfViewer>
            <div class="pdf-viewer-container">
                <embed [src]="safeUrl" type="application/pdf" width="100%" height="100%" />
                <button mat-flat-button class="next-pdf-button" (click)="playNext()">
                    PRÓXIMO
                </button>
            </div>
        </ng-template>

        <div *ngIf="showNextVideoOverlay && nextVideo" class="next-video-overlay">
            <p class="countdown-text">Próximo vídeo em {{ countdown }}</p>

            <div class="next-video-card">
                <img [src]="nextVideo.imageUrlFile" [alt]="nextVideo.title" class="next-video-thumbnail">
                <div class="next-video-details">
                    <h3>{{ nextVideo.title }}</h3>
                    <p class="next-video-description">{{nextVideo.description}}</p>
                </div>
            </div>

            <div class="next-video-actions">
                <button mat-flat-button class="cancel-button" (click)="cancelNextVideo()">CANCELAR</button>
                <button mat-flat-button class="watch-now-button" (click)="playNext()">ASSISTA AGORA</button>
            </div>
        </div>
    </div>
</div>